/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Provider_DescInputs */

const tr_iade_iptal_s2_provider_desc = /** @type {(inputs: Iade_Iptal_S2_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (VKN 3341266736; Antalya).`)
};

const en_iade_iptal_s2_provider_desc = /** @type {(inputs: Iade_Iptal_S2_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (VKN 3341266736; Antalya).`)
};

const de_iade_iptal_s2_provider_desc = /** @type {(inputs: Iade_Iptal_S2_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (VKN 3341266736; Antalya).`)
};

const ru_iade_iptal_s2_provider_desc = /** @type {(inputs: Iade_Iptal_S2_Provider_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi (VKN 3341266736; Antalya).`)
};

/**
* | output |
* | --- |
* | "Emonse® E-Ticaret Limited Şirketi (VKN 3341266736; Antalya)." |
*
* @param {Iade_Iptal_S2_Provider_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_provider_desc = /** @type {((inputs?: Iade_Iptal_S2_Provider_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Provider_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_provider_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_provider_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_provider_desc(inputs)
	return tr_iade_iptal_s2_provider_desc(inputs)
});